module.exports = __webpack_public_path__ + "img/reactfordesigners.5fd6e0fe.jpg";